import React, {useState, useMemo} from "react";
import {Row, Col} from "antd";
import moment from "moment";
import ExcelButtons from "./Components/ExcelButtons";
import ShiftManagementFilters from "./Components/ShiftManagementFilters";
import PoolShiftManagementFilters from "./Components/PoolShiftManagementFilters";
import {useFetch} from "../../hooks/useFetch";
import {useStore} from "../../hooks/useStore";
import ShiftTable from "./Components/ShiftTable";
import PoolShiftTable from "./Components/PoolShiftTable";

const ShiftManagement = () => {
    const stores = useStore();
    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [poolShiftStatus, setPoolShiftStatus] = useState("all");
    const [filters, setFilters] = useState({
        city: "all",
        company: undefined,
        subcompany: undefined,
        period: "choose",
        startDate: moment()
            .subtract(1, "d")
            .toDate(),
        endDate: moment().toDate(),
        searchText: undefined,
        courier: undefined,
        pool: "all"
    });
    const [poolFilters, setPoolFilters] = useState({
        pool: "all",
        date: moment().toDate(),
        searchText: undefined,
        city: "all"
    });
    const [workType, setWorkType] = useState(stores.meStore.map.filters.workType);
    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: () => {
            if (workType === "pool") {
                return stores.poolShiftStore.getCourierPoolShifts({
                    poolId: poolFilters.pool,
                    date: moment(poolFilters.date).format("YYYY-MM-DD"),
                    searchText: poolFilters.searchText,
                    city: poolFilters.city
                });
            } else {
                return stores.shiftStore.getShiftList({
                    limit: 10,
                    skip: (currentPage - 1) * 10,
                    city: filters.city,
                    company: filters.company,
                    subcompany: filters.subcompany,
                    period: filters.period,
                    startDate: filters.startDate,
                    endDate: filters.endDate,
                    searchText: filters.searchText
                });
            }
        },
        initialCall: true,
        dependencies: [filters, currentPage, workType, poolFilters, reloadData]
    });

    const filteredPoolData = useMemo(() => {
        if (!data?.data || poolShiftStatus === "all") {
            return data?.data || [];
        }
        return data.data.filter(item => item.status === poolShiftStatus);
    }, [data?.data, poolShiftStatus]);

    return (
        <div>
            <Row gutter={[8, 8]}>
                {workType === "pool" ? (
                    <PoolShiftManagementFilters
                        setCurrentPage={setCurrentPage}
                        poolFilters={poolFilters}
                        setPoolFilters={setPoolFilters}
                        workType={workType}
                        setWorkType={setWorkType}
                        setReloadData={() => setReloadData(!reloadData)}
                        status={poolShiftStatus}
                        setStatus={setPoolShiftStatus}
                    />
                ) : (
                    <ShiftManagementFilters
                        setCurrentPage={setCurrentPage}
                        setFilters={setFilters}
                        filters={filters}
                        workType={workType}
                        setWorkType={setWorkType}
                    />
                )}
            </Row>
            <Row>
                {workType != "pool" && (
                    <ExcelButtons
                        {...filters}
                        skip={(currentPage - 1) * 10}
                        limit={10}
                        setReloadData={() => setReloadData(!reloadData)}
                    />
                )}
            </Row>
            <Row style={{marginTop: 16}}>
                {workType === "pool" ? (
                    <PoolShiftTable
                        loading={loading}
                        data={filteredPoolData}
                        dataCount={filteredPoolData?.length}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        setReloadData={() => setReloadData(!reloadData)}
                    />
                ) : (
                    <ShiftTable
                        loading={loading}
                        data={data?.rows || []}
                        dataCount={data?.dataCount}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        setReloadData={() => setReloadData(!reloadData)}
                    />
                )}
            </Row>
        </div>
    );
};

export default ShiftManagement;
